<template>
  <div></div>
</template>

<script>
import actions from "../../common/actions.js";
import util from "../../common/util.js";
import houseItem from "./renwufwlistitem.vue";
import gps from "../../common/gps.js";

let touchmove = {};
export default {
  components: { houseItem },
  data() {
    return {
      list: [],
      hasMore: false,
      page: 0,
    };
  },
  mounted() {

    this.daka();
  },
  created() {},
  updated() {},
  computed: {},
  watch: {},
  methods: {
    daka() {
      if (
       false
      ) {
        alert("定位错误，请联系技术人员");
      } else {
        let data = {
          fangwu_id: this.$route.query.fangwu_id,
          x_count: this.$route.query.lng,
          y_count: this.$route.query.lat,
        };
        // let data = {
        //   fangwu_id: 'e4be078c164841579adc0539e2fc10d7',
        //   x_count: '116.131414485857',
        //   y_count: '39.911002031477004',
        // }
        // alert('id:'+this.$route.query.id+';'+'fangwu_id:'+this.$route.query.fangwu_id+';'+'x_count:'+ this.$route.query.lng+';'+'y_count:'+this.$route.query.lat)
        actions.getFwDistant(data).then((res) => {
          if (res.content < 500) {
            actions
              .renWuFangDaKa({
                rwid: this.$route.query.id,
                fangwu_id: data.fangwu_id,
                qrsj: "",
                qrr: "",
              })
              .then((res) => {
                if (res.is_success == 0) {
                  util.showToast("打卡成功");
                  setTimeout(() => {
                    this.$router.push({ name: "renwufwlist",query:{id:this.$route.query.id} });
                  }, 1500);
                }
              });
          } else if (res.content == -1) {
            util.showToast("请联系管理员设置坐标");
            setTimeout(() => {
              this.$router.push({ name: "renwufwlist",query:{id:this.$route.query.id} });
            }, 1500);
          } else {
            util.showToast("您不在房源附近");
            setTimeout(() => {
              this.$router.push({ name: "renwufwlist",query:{id:this.$route.query.id} });
            }, 1500);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.renwufwlist {
  font-size: 0.3rem;
  color: #333;
  padding-bottom: 1.3rem;
  .list {
    padding: 0 0.3rem;
    background-color: #fff;
    .next {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.9rem;
      margin: 0.3rem 0.1rem 0;
      color: #00ae66;
      border: 1px solid #00ae66;
      background-color: #fff;
    }
  }
  .list-null {
    padding: 0.6rem 0 0;
    text-align: center;
    font-size: 0.3rem;
    color: #666;
  }
  .btn-complete {
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1rem;
    bottom: 0;
    left: 0;
    right: 0;
    color: #fff;
    background-color: #00ae66;
  }
  .add-fw {
    position: fixed;
    left: calc(100% - 1.5rem);
    top: calc(100% - 4.2rem);
    height: 1.2rem;
    width: 1.2rem;
    background-image: url(../../images/add.png);
    background-size: 100%;
  }
}
</style>
